export enum FlowsRunnerElasticEvents {
    DeepLinkValidation = "DeepLinkValidation"
}